import { MainComponent } from "./components";

function App() {
  return (
    <div className="App max-w-screen">
      <MainComponent />
    </div>
  );
}

export default App;
